import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { tap, switchMap, map } from 'rxjs/operators';
import { ProductService } from '@services/product.service';
import { Product } from '@models/product';
import { ProductFilter } from '@models/filter';

@Component({
  selector: 'gob-product-list',
  templateUrl: './product-list.component.html',
  styleUrls: ['./product-list.component.scss'],
})
export class ProductListComponent implements OnInit {
  readonly GAMME_VENTE_PRIVEE: string = '6a7179119f926';

  loading: boolean = false;
  isFilter: boolean = false;
  isGrid: boolean = true;
  page: number = 0;
  size: number = 24;
  max: number = 0;
  filter: ProductFilter = new ProductFilter();
  products: Product[] = [];

  constructor(
    private pServ: ProductService,
    private router: ActivatedRoute,
  ) {
    this.loading = true;
    this.router.paramMap
      .pipe(
        switchMap((params) => {
          this.products = [];
          this.page = 0;
          this.filter = new ProductFilter(params.get('type'), params.get('id'));
          if (params.get('search')) {
            this.filter.fullname = params.get('search');
            this.filter.scoring = true;
          }
          return this.search(false);
        }),
      )
      .subscribe(() => (this.loading = false));
  }

  ngOnInit(): void {}

  next(page: number, filter: ProductFilter) {
    this.page = page;
    this.loading = true;
    this.search(true, filter).subscribe(() => (this.loading = false));
  }

  /**
   * @param append
   */
  search(append: boolean = false, filter?: ProductFilter) {
    let search: ProductFilter = filter ? filter : this.filter;

    return this.pServ
      .searchProducts(search, this.page * this.size, this.size)
      .pipe(
        map((products: any[]): Product[] =>
          products.filter((p: { isUsed: boolean; stocks: any[] }) => {
            // if used, keep only if there is some stock
            if (p.isUsed === true) {
              const totalStock = p.stocks.reduce(
                (acc, s) => acc + Number(s.qte || 0),
                0,
              );
              return totalStock > 0;
            }
            // if not used, always keep
            return true;
          }),
        ),
        tap((newProducts: Product[]) => {
          if (append) {
            this.products = [...this.products, ...newProducts];
          } else {
            this.products = newProducts;
          }

          // Show "see more" button only if page is full
          this.max =
            newProducts.length === this.size ? this.page + 2 : this.page;
        }),
      );
  }

  filterProduct(filter: ProductFilter) {
    this.isFilter = true;
    this.max = 0;
    this.page = 0;
    this.products = [];
    this.filter = { ...this.filter, ...filter };
    this.next(0, this.filter);
  }

  reset() {
    let params: any = this.router.snapshot.paramMap;
    this.products = [];
    this.page = 0;
    this.filter = new ProductFilter(params.get('type'), params.get('id'));
    this.search(false).subscribe(() => (this.loading = false));
  }
}
